<template>
	<AppDialog disableMaxWidth :dialogName="dialogName" width="750">
		<div class="new-project-container pt-4 px-9 display-flex flex-column flex-justify-space-between">
			<div>
				<div class="header">
					<SIcon class="mr-1" name="collaborative-space" width="20" height="24" />
					New shared space
				</div>
				<div class="header-description displa-flex flex-column mb-8">
					<div>Shared spaces let you collaborate with teammates to build features.</div>
					<div>Workspace admins have access to all shared spaces.</div>
				</div>
				<div class="name">
					<div class="title">Space name</div>
					<div class="sub-title">Give your space a meaningful name. it can be intuitive, department or subject</div>
					<AppTextField class="input mt-1" outlined dense v-model="projectName" hide-details single-line :placeholder="namePlaceholder" />
				</div>
				<div class="mt-5">
					<div @click="showDescriptionPart = !showDescriptionPart" v-if="!showDescriptionPart" class="add-description">Add description</div>
					<div v-else class="description">
						<div class="title">Description</div>
						<div class="sub-title">Help others understand what this is about. Visible in 'all spaces' page</div>
						<AppTextArea
							v-model="projectDescription"
							class="text-area input mt-1"
							rows="3"
							solo
							no-resize
							hide-details
							outlined
							dense
							:placeholder="descriptionPlaceholder"
						/>
					</div>
				</div>
			</div>
			<div class="dialog-bottom text-align-center">
				<AppTooltip position="top" text="Space name must be at least 2 characters long" :disabled="!isButtonDisabled">
					<PrimaryButton :disabled="isButtonDisabled" :loading="isLoading" class="create-button" @click="createNewProject">
						Create
					</PrimaryButton>
				</AppTooltip>
			</div>
		</div>
	</AppDialog>
</template>

<script>
import { mapActions } from 'vuex';
import { createProject } from '@/store/modules/projects/actions';
import AppDialog from '@/components/dialogs/AppDialog/AppDialog.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import ProjectsService from '@/utils/projects-service';
export default {
	name: 'NewProjectDialog',
	props: {
		dialogPromiseHandlers: { type: Object },
	},
	components: { AppDialog },
	computed: {
		isButtonDisabled() {
			return !(this.projectName?.length > 1) || this.isLoading;
		},
	},
	methods: {
		...mapActions([createProject.fullPath]),
		close() {
			this.dialogPromiseHandlers.resolve();
			AppDialogManagerService.closeCurrentDialog();
		},
		async createNewProject() {
			this.isLoading = true;
			const body = {
				title: this.projectName,
				description: this.projectDescription || '',
				access_type: this.projectType,
			};
			try {
				const project = await this[createProject.fullPath]({ project: body });
				this.close();
				if (!ProjectsService.isPersonalProject(body)) {
					await AppDialogManagerService.openCollaborateNewProjectDialog({ projectId: project.id });
				}
				this.$router.push({ name: 'Features', params: { pID: project.id } });
			} catch (err) {
				console.log(err);
				this.$toast.error('Failed creating project');
				this.close();
			}
		},
	},
	data: () => ({
		dialogName: 'NewProjectDialog',
		showDescriptionPart: false,
		isLoading: false,
		projectName: '',
		namePlaceholder: 'CDR Catalyst',
		projectDescription: '',
		descriptionPlaceholder: 'Features to delight prospects and supercharge SDRs, from reach-out to hand-off',
		projectType: 'workspace',
		typeOptions: [
			{
				icon: 'users-lock',
				title: 'Personal',
				subTitle: 'Only you can edit',
				description: 'Workspace admins have read-only access.',
				learnMoreLink: '',
				value: 'personal',
			},
			{
				icon: 'users',
				title: 'Workspace',
				subTitle: 'Collaborate with your team',
				description: 'Workspace admins have full access.',
				learnMoreLink: '',
				value: 'workspace',
			},
		],
	}),
};
</script>

<style scoped lang="scss">
.new-project-container {
	height: 460px;
	.header {
		font-size: 18px;
		font-weight: bold;
	}
	.title {
		color: #262626;
		font-size: 14px !important;
		font-weight: 500 !important;
	}
	.sub-title {
		font-size: 12px;
		color: #9e9e9e;
	}
	.add-description {
		text-decoration: underline;
		color: #9e9e9e;
		font-size: 14px;
		cursor: pointer;
	}
	.choose {
		background: #f3f3f3;
		border-radius: 5px;
		.v-radio {
			::v-deep {
				.v-input--selection-controls__input {
					display: none;
				}
			}
		}
	}
	.selected-option {
		background: white;
		border-radius: 5px;
	}
}
.create-button {
	width: 121px !important;
	height: 40px !important;
}
.header-description {
	font-size: 12px;
	color: #9e9e9e;
}
</style>
